
export default function (Component) {
  Component.options.__source = "src/components/Pages/PageBody.vue"
}
